import Lottie from "lottie-react";
import animationData from "./lf20_o6nierbk.json";

interface LoadingProps {
  isCenter?: boolean;
  isContained?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ isCenter, isContained }) => {
  const containerClasses = `flex items-center justify-center ${
    isContained
      ? "absolute inset-0 h-full w-full"
      : isCenter
      ? "fixed inset-0 h-full w-full"
      : "fixed inset-0 h-screen w-screen"
  }`;

  return (
    <div className={containerClasses} style={{ zIndex: 70 }}>
      <Lottie animationData={animationData} loop autoPlay className="h-40 w-40" />
    </div>
  );
};

export default Loading;
